export class ReachforBetterWorkCategory {
  public static chooseYourCareerInterest = 'Choose Your Career Interest';
  public static finance = 'Finance';
  public static forDrivenWomen = 'For Driven Women';
  public static humanResources = 'Human Resources';
  public static informationTechnology = 'Information Technology';
  public static marketing = 'Marketing';
  public static salesBusinessDevelopment = 'Sales/Business Development';
}
